import { IsTimestamp } from "../utils/decorators";

export interface Modified {
  modified?: ModifiedInfo
}

export class ModifiedInfo {
  readonly by: string;

  @IsTimestamp()
  readonly at: Date;

  constructor(init: ModifiedInfo);

  constructor(init?: ModifiedInfo) {
    this.by = init?.by!;
    this.at = init?.at!;
  }
}

export default ModifiedInfo;
